var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/about"}},[_c('div',{attrs:{"id":"home-staff"}},[_c('span',[_vm._v("Професорсько викладацький склад")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }